// eslint-disable-next-line no-restricted-imports
import { useQueries as useQueriesDefault } from '@tanstack/react-query';
import { useQueryClient } from '../contexts/QueryClientContext';
export const useQueries = (options, queryClient) => {
    const client = useQueryClient(queryClient);
    return useQueriesDefault(options, client);
};
//# sourceMappingURL=useQueries.js.map